module.exports = __webpack_public_path__ + "img/tariffs_card_1.6a49049.jpg";